import React from 'react'

const AddmitionContext = React.createContext()

export default AddmitionContext;